var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"cv-breadcrumb",class:[`${_vm.carbonPrefix}--breadcrumb`, { [`${_vm.carbonPrefix}--breadcrumb--no-trailing-slash`]: _vm.noTrailingSlash }],attrs:{"aria-label":_vm.ariaLabel}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }